import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate } from "react-router-dom";
import ListView from "../../utils/commonComponent/Custom/listView";
import ListSearchSection from "../../utils/commonComponent/Custom/ListSearchSection";
import { fetchQuery } from "../../utils/commonComponent/fetched";
import { submitSiteDelete } from "../../utils/commonComponent/delete";
import { AddButton } from "../../utils/commonComponent/Custom/Button";
import { getPermissions } from "../rbac/hasAccess";
import ClientExcelUploadModal from "./clientExcelUploadModal";

const headers = ["id", "companyName", "address", "branch", "gstNumber", "state", "vendorCode", "uniCode"];

const fields = [{ value: "Client", label: "Client" }];

const ClientMasterList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/master/editClient/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("clientMaster", row.id);

  const [clientList, setClientList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "Client");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
   // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
  };

  const getWhereClause = () => {
    let whereConditions = ["c.status = 1"];

    if (searchBy && searchKey) {
      const colName = {
        Client: "c.companyName",
        Address: "a.address",
        State: "c.state",
      }[searchBy];

      if (colName) {
        whereConditions.push(
          `LOWER(${colName}) LIKE LOWER('%${searchKey}%')`
        );
      }
    }

    // existing "today modified" condition
    if (props.isCount) {
      const today = new Date().toISOString().slice(0, 10);
      whereConditions.push(`DATE(c.lastmodified) = '${today}'`);
    }

    return whereConditions.length
      ? `WHERE ${whereConditions.join(" AND ")}`
      : "";
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause();

    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(currentPage) // ✅ FIXED
        }`;
    }

    return `SELECT c.id AS id, c.companyName AS companyName, GROUP_CONCAT(a.address SEPARATOR ' || ') AS address, b.branchName AS branch, c.gstNumber AS gstNumber, c.state AS state, c.email AS email, c.vendorCode AS vendorCode, c.uniCode AS uniCode, c.status AS status FROM clientMaster c LEFT JOIN addresses a
      ON FIND_IN_SET(a.id, REPLACE(REPLACE(REPLACE(c.address, ',', '|'), '|', ', '), '|', '')) > 0 LEFT JOIN branch b ON b.id = c.branch ${whereClause} GROUP BY c.id ORDER BY c.id DESC ${paginationSettings};`;
  };

  const getCountQuery = () => {
    const whereClause = getWhereClause();

    return `SELECT COUNT(DISTINCT c.id) AS totalRows FROM clientMaster c LEFT JOIN addresses a ON FIND_IN_SET(a.id, REPLACE(REPLACE(REPLACE(c.address, ',', '|'), '|', ', '), '|', '')) > 0 ${whereClause};`;
  };

  const fetchData = async () => {
    try {
      const [clientData, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);

      setClientList(clientData);
      setTotalRows(countResult?.[0]?.totalRows || 0);
    } catch (error) {
      console.error("Error fetching client data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("Client");
    setSearchKey("");
     // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/master/editClient/0"
          label="Add Client"
          icon={<AddIcon fontSize="small" />}
        />
      )}

      <ListSearchSection
        title="Search Client"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />

         <ClientExcelUploadModal />

         <br/>
         <br/>

      <ListView
        headers={headers}
        data={clientList}
        actions={{
          edit: handleEdit,
          delete: handleDelete,
        }}
        showCheckbox={true} //enable checkbox
        deleteTableName={"clients"}
        moduleId={props.moduleId}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPaginationChange={handlePaginationChange}
      />
    </>
  );
};

export default ClientMasterList;
